// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Timeout_backdrop__Ty0Ae","dialog":"Timeout_dialog__YsGpA","actions":"Timeout_actions__NW7X0"};